export enum TransactionPaymentDestinationEnum {
  PaymentLink = "payment_link",
  GoReach = "offer",
  Service = "goservice_contract",
  Program = "goservice",
  GinoAddOns = "gino_add_on",
  SubscribeToPlan = "subscribe_to_plan",
}

export enum TransactionTypeEnum {
  Paid = "paid",
  Received = "received",
}

export enum TransactionStatusEnum {
  Success = "success",
  Failed = "failed",
  Pending = "pending",
}
